export default {
    accepted_by: "Ким прийнято",
    additional_costs: "Витрати",
    additional_discount_correction: "Коригування за додатковою знижкою",
    additional_income: "Додатковий дохід",
    admin_statistics_future: "Статистика адміністратора про нові записи на майбутні дати",
    administrator_percent: "Відсоток адміністратора",
    administrator_sum: "Сума адміністратора",
    all_visits_of_current_branch_independent_of_status_including_cancelled: "Усі відвідування цього відділення, незалежно від статусу, в тому числі скасовані",
    apply: "Застосувати",
    assistant_percent: "Відсоток помічника",
    assistant_sum: "Сума помічника",
    average_cheque: "Середній чек",
    average_conversion_per_doctor_per_day: "Середній показник по лікарям в день",
    average_conversion_per_doctor_per_period: "Середній показник по лікарям за період",
    average_qty_of_goods_in_cheque: "Середня кількість товарів у квитанції",
    balance_amount: "Сплачено з депозиту",
    balance_return: "Повернення депозиту",
    became_permanent: "Стали постійними",
    by: "Ким",
    by_means: "За формою оплати",
    by_services: "За послугами",
    calculated_from_calendar_visit_duration: "Розраховується за тривалістю запису в календарі",
    came_again: "Прийшли знову",
    came_among_patients: "З них прийшли",
    came_later_over_total_primary: "Відсоток повторних відвідувачів від відвідувачів, які відвідали вперше",
    cancel_date: "Дата відміни",
    cancel_reason: "Причина відміни",
    cancelled_among_them: "З них були скасовані",
    cancelled_visits: "Відмінені візиты",
    cash_flow_statement: "Звіт про рух ДС",
    cash_received_report_day_explanation: "Отримані кошти за період: сплати за візити (за винятком таких видів сплат як депозитом, бонусом, гарантією тощо) плюс кошти від поповнення/зняття депозиту",
    cashdesk_report: "Касовий звіт",
    conversion: "Конверсія",
    conversion_came_to_permanent: "Конверсія (дійшов -> постійний)",
    cos: "Собівартість",
    cost_of_attracting_primary_patient: "Вартість залучення первинного пацієнта",
    cost_of_materials: "Вартість матеріалів",
    cost_of_visits_for_selected_interval: "Вартість відвідувань, здійснених протягом вибраного інтервалу",
    costs: "Витрати",
    crm_leads_analytics: "Аналітика заявок CRM",
    curator_id: "Id куратора",
    curator_name: "Ім'я куратора",
    curator_percent: "Відсоток куратора",
    curator_sum: "Сума куратора",
    daily_report: "Звіт за день",
    debt_payments: "Оплата боргів",
    debt_writeoff: "Списання боргів",
    debtor: "Боржник",
    debtors: "Боржники",
    debtors_statement: "Звіт по боржникам",
    deleted_payments_registry: "Реєстр видалених оплат",
    deposit_movements: "Руху депозитів",
    deposit_reconciliation_report: "Акт звірки по депозиту",
    details_by_visits: "Деталі по візитах",
    did_not_came_again: "Не прийшли знову",
    did_not_come_among_patients: "З них не прийшли",
    doctor_load_percent: "% завантаження лікаря",
    doctor_name: "Лікар",
    doctor_percent: "Відсоток лікаря",
    doctor_salary: "Зарплата лікаря",
    doctor_statistics: "Статистика по лікарях",
    doctor_sum: "Сума лікаря",
    doctors_conversion: "Конверсія по лікарям",
    doctors_load: "Завантаження лікарів",
    duration: "Тривалість",
    export_from: "Експорт з",
    exports: "Експорти",
    f057: "Форма 057",
    first_visit_date: "Дата першого візиту",
    first_visit_doctor: "Лікар першого візиту",
    full_name: "Ім'я",
    general_percent: "Загальний відсоток",
    have_later_visits_independent_of_interval: "Майбутні записи є незалежно від вибраного інтервалу",
    have_later_visits_within_selected_interval: "У вибраному інтервалі є інші записи",
    have_no_later_visits_independent_of_interval: "Немає подальших записів незалежно від вибраного інтервалу",
    hidden_columns: "Приховані колонки",
    hide_cancelled_visits: "Приховувати скасовані візити",
    how_much_was_paid_for_visit_for_the_whole_time_independent_of_selected_period: "Оплата за відвідування за весь час, незалежно від обраного інтервалу звітності",
    in_progress: "В процесі",
    includes_both_discount_on_specific_services_and_general_discount: "Включає знижки на окремі послуги та загальну знижку на відвідування",
    including_adjustment_for_general_visit_discount: "Включає коригування загальної знижки на відвідування",
    including_weighted_average_adjustment_for_general_visit_discount: "Включає середньозважене коригування загальної знижки за відвідування",
    income_by_doctors: "Виторг по лікарям",
    income_by_services: "Виторг по послугам",
    initiator: "Ініціатор",
    invoiced: "Виставлено рахунків",
    last_visit_date: "Дата останнього візиту",
    last_visit_doctor: "Лікар постаннього візиту",
    last_visit_recommendation: "Рекомендації останнього візиту",
    list_of_patients_with_visits_in_this_branch_for_selected_interval: "Список пацієнтів, які звернулися до цього відділення за вибраний інтервал",
    margins: "Валовий прибуток",
    materials_movement_analytics: "Аналітика руху матеріалів",
    minutes_visit_was_opened_in_control_system: "Протокол відкриття відвідування в системі контролю «початок і кінець відвідувань».",
    next_visit_date: "Дата наступного візиту",
    next_visit_doctor: "Лікар наступного візиту",
    number_of_patient_visits_for_given_interval: "Кількість відвідувань пацієнта за вибраний інтервал",
    only_fiscal_cheques: "Тільки фіскальні чеки",
    only_fiscal_payments: "Тільки фіскальні платежі",
    only_paid: "Тільки оплачені",
    operation_type: "Тип операціи",
    orthodontist: "Ортодонт",
    orthopedist: "Ортопед",
    paid_for: "Сплачено за",
    paid_from_account: "Сплачено з рахунку",
    paid_invoices: "Оплачені рахунки",
    paid_sum: "Сума оплати",
    patient_deposits: "Депозити пацієнтів",
    patient_id: "Id пацієнта",
    patient_name: "Пацієнт",
    patient_source: "Джерело пацієнта",
    patient_status: "Статус пацієнта",
    patients_conversion: "Конверсія пацієнтів",
    payments_registry: "Реєстр оплат",
    payments_within_interval_for_visits_happened_within_interval: "Сума платежів за обраний інтервал тільки за відвідування, які відбулися протягом обраного інтервалу",
    payments_within_interval_for_visits_happened_within_interval_excluding_refunds: "Сума платежів за вибраний інтервал лише за відвідування, здійснені протягом вибраного інтервалу (без повернення)",
    pdf_report: "PDF звіт",
    permanent_among_patients: "З них візити з постійними пацієнтами",
    pl_statement: "Звіт про доходи та витрати",
    plan_treatment_complexes: "Комплекси",
    plan_treatments: "План лікування",
    previous_visit_date: "Дата попереднього візиту",
    price_before_discount: "Сума до знижки",
    primary: "Первинний",
    primary_among_patients: "З них візити з первинними пацієнтами",
    primary_marketing_expenses: "Первинні витрати на маркетинг",
    primary_records: "Первинні - записано",
    primary_records_came: "Первинні - прийшли",
    primary_records_cancelled: "Первинна – скасована",
    primary_records_did_not_come: "Первинні - не прийшли",
    primary_records_further: "Первинні - записані пізніше",
    primary_records_revenue: "Первинні - виторг",
    product_name: "Назва продукту",
    recorded_later: "Перезаписано",
    records: "Записів",
    records_count: "Кіл-ть візитів",
    refunds_within_interval: "Відшкодування за вибраний інтервал",
    repeated: "Повторний",
    repeated_records: "Повторні - записано",
    repeated_records_came: "Повторні - прийшли",
    repeated_records_cancelled: "Повторно - скасовано",
    repeated_records_did_not_come: "Повторні - не прийшли",
    repeated_records_further: "Повторні - записані пізніше",
    repeated_records_revenue: "Повторні - виторг",
    report_days_limit: "Обмеження періоду звітності (днів)",
    report_is_too_heavy_confirm: "Звіт надто великий для перегляду на сторінці, вивантажити звіт у Excel файл?",
    revenue: "Виторг",
    revenue_per_hour: "Виторг в годину",
    revenues: "Виторг",
    revenues_report_day_explanation: "Оплати за візити за обраний період усіма способами, плюс додатковий дохід (з бухгалтерії) та кошти від продажу товарів",
    salary_report: "Звіт по зарплаті",
    saldo: "Сальдо",
    sale_date: "Дата продажу",
    sales_funnel_applications: "Лійка: Заявки та звернення",
    sales_funnel_plans: "Лійка: Плани лікування",
    see_all: "Бачити всіх",
    see_only_yourself: "Бачити тільки себе",
    services_amount: "Кіл-ть послуг",
    show_block_as_free_time: "Враховувати блоки як вільний час",
    show_completed_visits: "Показувати завершені візити",
    show_deleted: "Показувати видалені",
    show_deleted_doctors: "Показувати видаленим лікарям",
    show_only_new_patients: "Відображати тільки нових пацієнтів",
    source_of_patient_acquisition: "Початкове джерело привабливості пацієнта",
    source_of_visit_acquisition: "Відвідайте джерело створення",
    source_type: "Тип джерела",
    technic_percent: "Відсоток техніка",
    technic_sum: "Сума техніка",
    therapist: "Терапевт",
    total_acquiring_deductions: "Загальний відсоток еквайрингу",
    total_cost_of_services: "Загальна вартість послуг",
    total_materials_deductions: "Загальний відсоток матеріалів",
    total_patients: "Кількість записаних пацієнтів",
    total_payments: "Загальна сума платежів",
    total_primary: "Всього первинних",
    total_primary_patients_records: "Загальний облік первинних хворих",
    total_revenue: "Загальний виторг",
    total_salary: "Загальна зарплата",
    total_technic_laboratory_deductions: "Загальний відсоток техніків / лабораторії",
    total_unique_primary_patients: "Всього унікальних первинних пацієнтів",
    total_with_deductions: "Загальна сума з відрахуваннями",
    unique_patients_recorded_during_selected_report_interval: "Кількість унікальних пацієнтів, зареєстрованих у вибраному інтервалі звіту",
    unique_patients_with_first_visit_for_interval: "Унікальні пацієнти з першим візитом протягом вибраного інтервалу",
    unpaid_invoices: "Неоплачені рахунки",
    updated_date: "Дата оновлення",
    visit_id: "Id запису",
    visit_price_including_all_discounts: "Вартість відвідування з урахуванням усіх знижок",
    visit_statistics: "Статистика візитів",
    visits_by_source: "Візити за джерелами",
    visits_cost_over_services_count: "Вартість відвідувань за кількість послуг",
    visits_detailed: "Візити (розширений)",
    visits_of_current_branch_which_has_services_or_has_status_other_than_not_come: "Відвідування цього відділення з позначкою послуг або статусом, відмінним від «не надійшло»",
    visits_of_current_branch_which_have_services_or_have_status_came: "Відвідування з наданням послуг або статус «пацієнт прибув»",
    visits_price_including_all_discounts: "Вартість відвідування з урахуванням усіх знижок",
    where_came_from: "Звідки прийшов(-ла)",
    who_cancelled: "Хто відмінив",
    who_changed_status: "Ким змінено статус (Оплата / Прийшов)",
    who_created: "Ким створено",
    who_updated: "Ким змінено",
    with_patient: "З пацієнтом",
    worked_days: "Відпрацьованих днів",
    worked_hours: "Відпрацьованих годин",
    your_report_is_processing: "Ваш звіт формується. Ви отримаєте сповіщення, як тільки він буде готовий."
}
